(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-cod-modal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal = document.querySelector('[data-vrs-cod-modal]');
  if (!modal) return;

  var panel        = modal.querySelector('.varsy-cod-modal__panel');
  var form         = modal.querySelector('[data-vrs-cod-form]');
  var body         = modal.querySelector('[data-vrs-cod-body]');
  var itemBlock    = modal.querySelector('[data-vrs-cod-item]');
  var itemTitle    = modal.querySelector('[data-vrs-cod-item-title]');
  var itemVariant  = modal.querySelector('[data-vrs-cod-item-variant]');
  var qtyGroup     = modal.querySelector('[data-vrs-cod-qty-group]');
  var qtyInput     = modal.querySelector('[data-vrs-cod-qty-input]');
  var bundleItem1        = modal.querySelector('[data-vrs-cod-bundle-item-1]');
  var bundleItem1Title   = modal.querySelector('[data-vrs-cod-bundle-item-1-title]');
  var bundleItem1Variant = modal.querySelector('[data-vrs-cod-bundle-item-1-variant]');
  var bundleItem2        = modal.querySelector('[data-vrs-cod-bundle-item-2]');
  var bundleItem2Title   = modal.querySelector('[data-vrs-cod-bundle-item-2-title]');
  var bundleItem2Variant = modal.querySelector('[data-vrs-cod-bundle-item-2-variant]');
  var bundleTotalEl      = modal.querySelector('[data-vrs-cod-bundle-total]');
  var submitBtn    = modal.querySelector('[data-vrs-cod-submit]');
  var submitLabel  = modal.querySelector('[data-vrs-cod-submit-label]');
  var errorEl      = modal.querySelector('[data-vrs-cod-error]');
  var successEl    = modal.querySelector('[data-vrs-cod-success]');
  var webhookUrl   = modal.dataset.webhookUrl;
  var currency     = modal.dataset.currency || 'MAD';
  var thankYouUrl  = modal.dataset.thankYouUrl;

  var submitDefaultLabel = submitLabel ? submitLabel.textContent : 'Confirm order';
  var submittingLabel    = modal.dataset.submittingLabel || 'Sending...';
  var validationMessage  = modal.dataset.validationMessage || 'Check the fields marked in red.';
  var errorMessage       = modal.dataset.errorMessage || 'Something went wrong. Try again.';
  var timeoutHeading     = modal.dataset.timeoutHeading || '';
  var successHeadingEl   = modal.querySelector('[data-vrs-cod-success-heading]');
  var successDefaultHeading = successHeadingEl ? successHeadingEl.textContent : '';

  var lastFocused = null;
  var pending = null; /* { context, lineItems, bundle } */

  /* Moroccan mobile, accepting every shape customers actually type:
     +212600000000, 00212600000000, 212600000000, 0600000000, and the
     bare 9-digit 600000000. The national prefix is optional; what is
     fixed is the 5/6/7 operator digit followed by 8 more digits. */
  var PHONE_PATTERN = /^(?:(?:\+|00)?212|0)?[5-7]\d{8}$/;

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return (cents / 100).toFixed(0);
  }

  /* ── Open / Close ─────────────────────────────────────── */

  function resetView() {
    form.hidden = false;
    successEl.hidden = true;
    if (successHeadingEl) successHeadingEl.textContent = successDefaultHeading;
    form.reset();
    hideError();
    qtyInput.value = '1';
  }

  function openModal(context, data) {
    pending = { context: context, lineItems: data.lineItems || [], bundle: data.bundle || null };

    if (context === 'product') {
      itemBlock.hidden = false;
      qtyGroup.hidden = false;
      itemTitle.textContent = data.title || '';
      itemVariant.textContent = data.variantTitle || '';
    } else {
      itemBlock.hidden = true;
      qtyGroup.hidden = true;
    }

    if (context === 'bundle' && data.lineItems && data.lineItems.length === 2) {
      var main = data.lineItems[0];
      var partner = data.lineItems[1];
      if (bundleItem1) bundleItem1.hidden = false;
      if (bundleItem1Title) bundleItem1Title.textContent = main.title || '';
      if (bundleItem1Variant) bundleItem1Variant.textContent = main.variant_title || '';
      if (bundleItem2) bundleItem2.hidden = false;
      if (bundleItem2Title) bundleItem2Title.textContent = partner.title || '';
      if (bundleItem2Variant) bundleItem2Variant.textContent = partner.variant_title || '';
      if (bundleTotalEl && data.bundle) {
        bundleTotalEl.textContent = money(data.bundle.priceCents);
        bundleTotalEl.hidden = false;
      }
    } else {
      if (bundleItem1) bundleItem1.hidden = true;
      if (bundleItem2) bundleItem2.hidden = true;
      if (bundleTotalEl) bundleTotalEl.hidden = true;
    }

    resetView();

    lastFocused = document.activeElement;
    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('varsy-cod-modal--open');
    });
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var firstField = form.querySelector('[data-vrs-cod-field]');
    if (firstField) firstField.focus();
  }

  function closeModal() {
    modal.classList.remove('varsy-cod-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!modal.classList.contains('varsy-cod-modal--open')) modal.hidden = true;
    }, 320);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-vrs-cod-open]');
    if (opener) {
      e.preventDefault();
      handleOpenTrigger(opener);
      return;
    }
    if (e.target.closest('[data-vrs-cod-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('varsy-cod-modal--open')) closeModal();
  });

  /* ── Trigger handling ─────────────────────────────────── */

  function handleOpenTrigger(opener) {
    var context = opener.dataset.codContext;

    if (context === 'product') {
      var info = document.querySelector('[data-vrs-product-info]');
      if (!info) return;
      var variantsEl = info.querySelector('[data-vrs-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var idInput = info.querySelector('[data-vrs-variant-id]');
      var variantId = idInput ? parseInt(idInput.value, 10) : null;
      var variant = variants.find(function (v) { return v.id === variantId; });
      if (!variant) return;

      var titleEl = document.querySelector('.varsy-pdp-info__title');
      var productTitle = titleEl ? titleEl.textContent.trim() : variant.title;

      openModal('product', {
        title: productTitle,
        variantTitle: variant.title || '',
        lineItems: [{
          variant_id: variant.id,
          quantity: 1,
          title: productTitle,
          variant_title: variant.title || '',
          price: variant.price
        }]
      });
    } else if (context === 'cart') {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) return;
          var lineItems = cart.items.map(function (item) {
            return {
              variant_id: item.variant_id,
              quantity: item.quantity,
              title: item.product_title,
              variant_title: item.variant_title || '',
              price: item.price
            };
          });
          openModal('cart', { lineItems: lineItems });
        })
        .catch(function (err) {
          console.error('COD cart lookup failed:', err);
        });
    } else if (context === 'bundle') {
      var activeBundle = window.VarsyBundle && window.VarsyBundle.getActiveBundle();
      if (!activeBundle) return;

      openModal('bundle', {
        lineItems: activeBundle.lineItems,
        bundle: {
          label: activeBundle.label,
          priceCents: activeBundle.priceCents,
          compareAtCents: activeBundle.compareAtCents
        }
      });

      /* Bundles never touch the real cart, so Shopify's own Meta channel
         never sees them -- publish our own event here, once, at the
         moment the customer commits to the bundle by opening the popup.
         Requires a Custom Pixel (Settings -> Customer events) subscribed
         to this event name to turn it into a real Meta AddToCart. */
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('varsy_bundle_add_to_cart', {
          value: activeBundle.priceCents / 100,
          currency: currency,
          label: activeBundle.label
        });
      }
    }
  }

  /* ── Quantity stepper (product context only) ──────────── */

  qtyGroup.addEventListener('click', function (e) {
    if (e.target.closest('[data-vrs-cod-qty-dec]')) {
      var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = next;
    } else if (e.target.closest('[data-vrs-cod-qty-inc]')) {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    }
  });

  /* ── Validation ───────────────────────────────────────── */

  function hideError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
    form.querySelectorAll('[data-vrs-cod-field]').forEach(function (f) {
      f.removeAttribute('aria-invalid');
    });
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function validate() {
    var fields = form.querySelectorAll('[data-vrs-cod-field]');
    var firstInvalid = null;
    var valid = true;

    fields.forEach(function (field) {
      var value = field.value.trim();
      var optional = field.hasAttribute('data-vrs-cod-optional');
      var ok = optional || value.length > 0;
      if (field.dataset.vrsCodField === 'phone') {
        ok = PHONE_PATTERN.test(value.replace(/[\s.()\-]/g, ''));
      }
      if (!ok) {
        valid = false;
        field.setAttribute('aria-invalid', 'true');
        if (!firstInvalid) firstInvalid = field;
      } else {
        field.removeAttribute('aria-invalid');
      }
    });

    if (!valid) {
      showError(validationMessage);
      if (firstInvalid) firstInvalid.focus();
    }

    return valid;
  }

  /* ── Submit ───────────────────────────────────────────── */

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hideError();
    if (!validate()) return;
    if (!webhookUrl) {
      showError(errorMessage);
      return;
    }

    var lineItems = pending ? pending.lineItems : [];
    if (pending && pending.context === 'product' && lineItems[0]) {
      lineItems[0].quantity = parseInt(qtyInput.value, 10) || 1;
    }

    var payload = {
      context: pending ? pending.context : 'product',
      customer: {
        name: form.querySelector('[data-vrs-cod-field="name"]').value.trim(),
        phone: form.querySelector('[data-vrs-cod-field="phone"]').value.trim(),
        city: form.querySelector('[data-vrs-cod-field="city"]').value.trim(),
        address: form.querySelector('[data-vrs-cod-field="address"]').value.trim()
      },
      currency: currency,
      source: {
        shop: window.location.hostname,
        page_url: window.location.href,
        locale: document.documentElement.lang || 'en'
      },
      line_items: lineItems
    };

    if (pending && pending.context === 'bundle' && pending.bundle) {
      /* Both line_items above already carry their own allocated price --
         this object is bundle-level context for the Apps Script (e.g. to
         apply the per-line discount against list price) and for ops. */
      payload.bundle = {
        label: pending.bundle.label,
        price_centimes: pending.bundle.priceCents,
        compare_at_centimes: pending.bundle.compareAtCents
      };

      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('varsy_bundle_initiate_checkout', {
          value: pending.bundle.priceCents / 100,
          currency: currency,
          label: pending.bundle.label
        });
      }
    }

    submitBtn.disabled = true;
    if (submitLabel) submitLabel.textContent = submittingLabel;

    /* Apps Script round-trips can be slow (it answers with a redirect to
       googleusercontent, so it's two hops), and a customer staring at a
       spinner assumes the order failed and resubmits. After 8s, show the
       confirmation regardless: the request is still in flight and the
       order still gets created, we just stop making them wait on it.
       settled guards against the fetch landing afterwards and yanking
       the page out from under a customer already reading the message. */
    var settled = false;
    var slowTimer = setTimeout(function () {
      if (settled) return;
      settled = true;
      if (successHeadingEl && timeoutHeading) successHeadingEl.textContent = timeoutHeading;
      form.hidden = true;
      successEl.hidden = false;
    }, 8000);

    fetch(webhookUrl, {
      method: 'POST',
      /* text/plain avoids a CORS preflight (OPTIONS) request — Google Apps
         Script Web Apps don't handle preflight, so application/json here
         gets silently blocked by the browser before the POST ever sends.
         The body is still JSON; Apps Script reads it as raw text either way. */
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('COD submit failed');
        return res.json().catch(function () { return {}; });
      })
      .then(function (result) {
        if (result && result.ok === false) throw new Error(result.error || 'COD submit rejected');
        if (settled) return; /* 8s message already shown — leave it alone */
        settled = true;
        clearTimeout(slowTimer);

        if (thankYouUrl) {
          var totalCents = lineItems.reduce(function (sum, item) {
            return sum + (Number(item.price) || 0) * (Number(item.quantity) || 0);
          }, 0);
          var redirectUrl = new URL(thankYouUrl, window.location.origin);
          redirectUrl.searchParams.set('value', (totalCents / 100).toFixed(2));
          redirectUrl.searchParams.set('currency', currency);
          if (result && result.draft_order_id) {
            redirectUrl.searchParams.set('order_id', result.draft_order_id);
          }
          window.location.href = redirectUrl.toString();
          return;
        }

        form.hidden = true;
        successEl.hidden = false;
      })
      .catch(function (err) {
        console.error('COD order error:', err);
        /* Past the 8s mark the customer is already looking at the
           confirmation; don't replace it with an error for a request
           that may well have created the order anyway. */
        if (settled) return;
        settled = true;
        clearTimeout(slowTimer);
        showError(errorMessage);
      })
      .finally(function () {
        submitBtn.disabled = false;
        if (submitLabel) submitLabel.textContent = submitDefaultLabel;
      });
  });

  window.VarsyCodModal = { open: openModal, close: closeModal };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-collection-filter-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var drawer   = document.querySelector('[data-vrs-drawer]');
  if (!drawer) return;

  var openBtns  = document.querySelectorAll('[data-vrs-open-filter]');
  var closeBtns = drawer.querySelectorAll('[data-vrs-drawer-close]');
  var form      = drawer.querySelector('[data-vrs-filter-form]');
  var badge     = document.querySelector('[data-vrs-active-filter-count]');

  function open() {
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('vrs-drawer--open');
    });
    document.body.style.overflow = 'hidden';
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }

  function close() {
    drawer.classList.remove('vrs-drawer--open');
    document.body.style.overflow = '';
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { drawer.hidden = true; }, 320);
  }

  openBtns.forEach(function (b) { b.addEventListener('click', open); });
  closeBtns.forEach(function (b) { b.addEventListener('click', close); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* ── Active filter badge ──────────────────────────────── */
  if (form && badge) {
    var checkedCount = form.querySelectorAll('input[type="checkbox"]:checked').length;
    var filledCount  = Array.from(form.querySelectorAll('input[type="number"]'))
                           .filter(function (i) { return i.value !== ''; }).length;
    var total = checkedCount + filledCount;
    if (total > 0) {
      badge.textContent = total;
      badge.hidden = false;
    }
  }

  /* ── Live checkbox state ──────────────────────────────── */
  if (form) {
    form.querySelectorAll('.varsy-coll-drawer__check input').forEach(function (input) {
      input.addEventListener('change', function () {
        input.closest('.varsy-coll-drawer__check')
             .classList.toggle('varsy-coll-drawer__check--on', input.checked);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-collection-toolbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var toolbar = document.querySelector('[data-vrs-toolbar]');
  if (!toolbar) return;

  /* ── Sort ───────────────────────────────────────────────── */
  var details   = toolbar.querySelector('[data-vrs-sort-details]');
  var curLabel  = toolbar.querySelector('[data-vrs-current-sort]');
  var options   = toolbar.querySelectorAll('[data-vrs-sort-value]');

  /* Read current sort_by from URL */
  function currentSortValue() {
    return new URL(window.location.href).searchParams.get('sort_by') || '';
  }

  /* Update visible label and highlight active option */
  function syncSort() {
    var active = currentSortValue();
    options.forEach(function (btn) {
      var isActive = btn.dataset.vrsSortValue === active;
      btn.setAttribute('aria-current', isActive ? 'true' : 'false');
      if (isActive && curLabel) curLabel.textContent = btn.textContent;
    });
    /* Fallback: show first option label when no sort_by in URL */
    if (!active && options.length > 0 && curLabel && !curLabel.textContent) {
      curLabel.textContent = options[0].textContent;
    }
  }

  /* Navigate with new sort param, preserving other params */
  options.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', btn.dataset.vrsSortValue);
      window.location.href = url.toString();
    });
  });

  /* Close sort menu when clicking outside */
  document.addEventListener('click', function (e) {
    if (details && details.open && !details.contains(e.target)) {
      details.open = false;
    }
  });

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && details && details.open) {
      details.open = false;
    }
  });

  syncSort();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var footer = document.querySelector('.varsy-footer');
  if (!footer) return;

  var langToggle = footer.querySelector('[data-vrs-lang-toggle]');
  var langList   = footer.querySelector('[data-vrs-lang-list]');

  if (langToggle && langList) {
    langToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = langToggle.getAttribute('aria-expanded') === 'true';
      langToggle.setAttribute('aria-expanded', String(!expanded));
      langList.hidden = expanded;
    });
    document.addEventListener('click', function (e) {
      if (!footer.contains(e.target)) return;
      if (!langList.contains(e.target) && !langToggle.contains(e.target)) {
        langList.hidden = true;
        langToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-hero-statement"] && !Shopify.designMode) return;
  try {
    
(function () {
  var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!motionOk) return;

  document.querySelectorAll('.varsy-hero-statement[data-parallax="true"]').forEach(function (section) {
    var line1 = section.querySelector('[data-vrs-line="1"]');
    var line2 = section.querySelector('[data-vrs-line="2"]');
    if (!line1 || !line2) return;

    window.addEventListener('scroll', function () {
      var progress = Math.min(1, window.scrollY / 500);
      line1.style.transform = 'translateX(' + (-progress * 24) + 'px)';
      line2.style.transform = 'translateX(' + (progress * 18) + 'px)';
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-product-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var gallery = document.querySelector('[data-vrs-gallery]');
  if (!gallery) return;

  var track = gallery.querySelector('[data-vrs-gallery-track]');
  var dotsContainer = gallery.querySelector('[data-vrs-gallery-dots]');
  if (!track) return;

  var active = 0;

  function updateDots(i) {
    if (!dotsContainer) return;
    dotsContainer.querySelectorAll('.varsy-pdp-gallery__dot').forEach(function (d, di) {
      d.classList.toggle('varsy-pdp-gallery__dot--on', di === i);
    });
  }

  track.addEventListener('scroll', function () {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (i !== active) {
      active = i;
      updateDots(i);
    }
  }, { passive: true });

  if (dotsContainer) {
    dotsContainer.querySelectorAll('.varsy-pdp-gallery__dot').forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.dataset.i, 10);
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });
  }

  /* Jump to the image assigned to a variant in Admin when the customer
     picks that variant in the buy section. Sizes normally share one image,
     so this only actually moves when the image genuinely differs. */
  function goToMediaId(mediaId) {
    if (!mediaId) return;
    var slides = track.querySelectorAll('.varsy-pdp-gallery__slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaId !== String(mediaId)) continue;
      if (i === active) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      active = i;
      updateDots(i);
      return;
    }
  }

  document.addEventListener('varsy:variant:change', function (e) {
    if (e.detail) goToMediaId(e.detail.mediaId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-product-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-vrs-product-info]');
  if (!root) return;

  var variantsEl    = root.querySelector('[data-vrs-variants]');
  var variants      = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var idInput       = root.querySelector('[data-vrs-variant-id]');
  var optionButtons = root.querySelectorAll('[data-vrs-option-index]');
  var addBtn      = root.querySelector('[data-vrs-add]');
  var addLabel    = root.querySelector('[data-vrs-add-label]');
  var priceEl     = root.querySelector('[data-vrs-price]');
  var priceCompareEl = root.querySelector('[data-vrs-price-compare]');
  var priceSaleEl    = root.querySelector('[data-vrs-price-sale]');
  var scarcity    = root.querySelector('[data-vrs-scarcity]');
  var scarcityLbl = root.querySelector('[data-vrs-scarcity-label]');
  var lowQuantity = root.dataset.lowQuantity;

  var variantMediaEl = root.querySelector('[data-vrs-variant-media]');
  var variantMedia   = variantMediaEl ? JSON.parse(variantMediaEl.textContent) : {};

  var bundleRoot        = root.querySelector('[data-vrs-bundle]');
  var bundleDataEl      = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-data]') : null;
  var bundleData        = null;
  if (bundleDataEl) {
    try {
      bundleData = JSON.parse(bundleDataEl.textContent);
    } catch (err) {
      /* A malformed row in the bundle price table setting (e.g. a
         currency symbol or comma left in the price column) would
         otherwise throw here and silently kill the rest of this
         script, including the ordinary size/swatch pickers below.
         Fail the bundle widget alone instead. */
      console.error('Varsy bundle widget: malformed bundle data, widget disabled.', err);
      bundleRoot.hidden = true;
    }
  }
  var bundleChoiceBtns  = bundleRoot ? bundleRoot.querySelectorAll('[data-vrs-bundle-choice]') : [];
  var bundlePanel       = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-panel]') : null;
  var bundleSizeGrids   = bundleRoot ? bundleRoot.querySelectorAll('[data-vrs-bundle-partner-sizes]') : [];
  var bundleSinglePriceEl = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-single-price]') : null;
  var bundleLabelEl    = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-label]') : null;
  var bundleSubEl      = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-sub]') : null;
  var bundlePriceEl    = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-price]') : null;
  var bundleCompareEl  = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-compare]') : null;
  var bundleSavingEl   = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-saving]') : null;
  var bundleSingleCta  = root.querySelector('[data-vrs-single-cta]');
  var bundleCta        = root.querySelector('[data-vrs-bundle-cta]');
  var bundleCodBtn     = root.querySelector('[data-vrs-bundle-cod-btn]');

  var bundleCurrentRows = bundleRoot ? bundleRoot.querySelectorAll('[data-vrs-bundle-current-row]') : [];
  var bundleOpenPickerBtn = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-open-picker]') : null;
  var bundlePicker      = bundleRoot ? bundleRoot.querySelector('[data-vrs-bundle-picker]') : null;
  var bundlePickerClose = bundlePicker ? bundlePicker.querySelectorAll('[data-vrs-bundle-picker-close]') : [];
  var bundlePickerItems = bundlePicker ? bundlePicker.querySelectorAll('[data-vrs-bundle-picker-item]') : [];
  var bundlePickerLastFocused = null;

  var bundleActiveChoice  = 'single';
  var bundleActivePartner = null;
  var bundlePartnerVariant = {}; /* partner handle -> currently selected variant id, or null until explicitly chosen after a swap */
  var bundleActiveState   = null; /* what window.VarsyBundle exposes */

  if (bundleData) {
    Object.keys(bundleData.partners).forEach(function (handle) {
      bundlePartnerVariant[handle] = bundleData.partners[handle].defaultVariantId;
    });
    bundlePickerItems.forEach(function (btn) {
      if (btn.classList.contains('varsy-bundle__picker-item--on')) bundleActivePartner = btn.dataset.vrsBundlePickerItem;
    });
  }

  var singleCodBtn = root.querySelector('[data-vrs-single-cod-btn]');
  var sizeOptionIndex = parseInt(root.dataset.sizeOptionIndex, 10);

  var currentVariantId = idInput ? parseInt(idInput.value, 10) : null;
  var currentVariant   = variants.find(function (v) { return v.id === currentVariantId; });

  /* Seed every axis from a real variant so colour/other options still start
     chosen, then blank the size axis: the customer must pick that one
     themselves. idInput is already empty in that case, so nothing can be
     added to the cart until they do. */
  var seedVariant = currentVariant || variants.find(function (v) { return v.available; }) || variants[0];
  var selected = seedVariant ? seedVariant.options.slice() : [];
  if (!isNaN(sizeOptionIndex) && sizeOptionIndex >= 0 && !currentVariant) {
    selected[sizeOptionIndex] = null;
  }

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return (cents / 100).toFixed(0);
  }

  function findVariant(options) {
    if (!options.length) return undefined;
    /* An axis still unset means no specific variant is chosen yet. */
    for (var i = 0; i < options.length; i++) {
      if (options[i] == null) return undefined;
    }
    return variants.find(function (v) {
      return v.options.length === options.length && v.options.every(function (val, i) {
        return val === options[i];
      });
    });
  }

  /* Availability check that tolerates unset axes -- with no size chosen,
     a colour is "available" if any variant in that colour is in stock. */
  function anyAvailable(options) {
    return variants.some(function (v) {
      return v.available && v.options.every(function (val, i) {
        return options[i] == null || options[i] === val;
      });
    });
  }

  /* Nothing fully chosen: keep the buy buttons shut and prompt for a size. */
  function updateBuyState() {
    var variant = findVariant(selected);
    if (variant) {
      applyVariant(variant);
      return;
    }
    if (idInput) idInput.value = '';
    if (addBtn) {
      addBtn.disabled = true;
      if (addLabel) addLabel.textContent = addBtn.dataset.selectSizeLabel || addBtn.dataset.addLabel || '';
    }
    if (singleCodBtn) singleCodBtn.disabled = true;
  }

  function outClass(btn) {
    return btn.classList.contains('varsy-pdp-info__swatch') ? 'varsy-pdp-info__swatch--out' : 'varsy-pdp-info__size--out';
  }

  function onClass(btn) {
    return btn.classList.contains('varsy-pdp-info__swatch') ? 'varsy-pdp-info__swatch--on' : 'varsy-pdp-info__size--on';
  }

  function refreshSelectedClasses() {
    optionButtons.forEach(function (btn) {
      var idx = parseInt(btn.dataset.vrsOptionIndex, 10);
      var isSelected = selected[idx] === btn.dataset.vrsOptionValue;
      btn.classList.toggle(onClass(btn), isSelected);
      btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });
  }

  function refreshAvailability() {
    optionButtons.forEach(function (btn) {
      var idx = parseInt(btn.dataset.vrsOptionIndex, 10);
      var candidate = selected.slice();
      candidate[idx] = btn.dataset.vrsOptionValue;
      var isAvailable = anyAvailable(candidate);
      btn.classList.toggle(outClass(btn), !isAvailable);
      btn.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
    });
  }

  function applyVariant(variant) {
    if (!variant) return;

    if (idInput) idInput.value = variant.id;

    /* Let the gallery jump to the image assigned to this variant in Admin */
    var mediaId = variantMedia[variant.id];
    if (mediaId) {
      document.dispatchEvent(new CustomEvent('varsy:variant:change', {
        detail: { variantId: variant.id, mediaId: mediaId }
      }));
    }

    if (priceEl) {
      var onSale = variant.compare_at_price > variant.price;
      priceEl.classList.toggle('varsy-pdp-info__price--sale', onSale);
      if (priceSaleEl) priceSaleEl.textContent = money(variant.price);
      if (priceCompareEl) {
        priceCompareEl.hidden = !onSale;
        if (onSale) priceCompareEl.textContent = money(variant.compare_at_price);
      }
    }

    if (singleCodBtn) singleCodBtn.disabled = !variant.available;

    if (addBtn) {
      var available = variant.available;
      addBtn.disabled = !available;

      if (!available) {
        if (addLabel) addLabel.textContent = addBtn.dataset.soldOutLabel || 'Sold out';
      } else {
        var showPrice = addBtn.dataset.showPrice === 'true';
        var base = addBtn.dataset.addLabel || 'Add to bag';
        if (addLabel) {
          if (showPrice) {
            addLabel.innerHTML = base + ' — <span data-vrs-add-price>' + money(variant.price) + '</span>';
          } else {
            addLabel.textContent = base;
          }
        }
      }
    }

    if (scarcity && scarcityLbl) {
      if (lowQuantity && variant.available) {
        var qty = parseInt(lowQuantity, 10);
        var singleLabel = scarcity.dataset.singleLabel || 'Final piece';
        var fewLabel    = scarcity.dataset.fewLabel || 'Only {count} left';
        scarcityLbl.textContent = qty === 1
          ? singleLabel.toUpperCase()
          : fewLabel.replace('{count}', qty).toUpperCase();
        scarcity.hidden = false;
      } else {
        scarcity.hidden = true;
      }
    }

    recomputeBundle(variant);
  }

  /* ── Bundle widget ────────────────────────────────────────
     No-ops safely on every product page that has no bundle rule
     configured -- bundleRoot is null, so every guard below returns
     immediately and every querySelectorAll is an empty, harmless list. */

  function updateBundleCtaState() {
    if (bundleCodBtn) bundleCodBtn.disabled = bundleActiveChoice !== 'bundle' || !bundleActiveState;
  }

  function setBundleChoice(choice) {
    if (!bundleRoot) return;
    bundleActiveChoice = choice;
    bundleChoiceBtns.forEach(function (btn) {
      btn.setAttribute('aria-checked', btn.dataset.vrsBundleChoice === choice ? 'true' : 'false');
    });
    if (bundlePanel) bundlePanel.hidden = choice !== 'bundle';

    var showBundleCta = choice === 'bundle' && !!bundleCta;
    if (bundleSingleCta) bundleSingleCta.hidden = showBundleCta;
    if (bundleCta) bundleCta.hidden = !showBundleCta;

    if (choice !== 'bundle') bundleActiveState = null;
    updateBundleCtaState();
  }

  /* opts.resetSize (true only on an explicit swap via the picker, never
     on initial load) clears that partner's size selection -- sizes and
     their variant ids differ per product, so a size chosen on the
     previous partner would silently resolve to the wrong variant on
     the new one if it carried over. */
  function setBundlePartner(handle, opts) {
    if (!bundleRoot || !bundleData || !bundleData.partners[handle]) return;
    bundleActivePartner = handle;

    bundlePickerItems.forEach(function (btn) {
      var isOn = btn.dataset.vrsBundlePickerItem === handle;
      btn.classList.toggle('varsy-bundle__picker-item--on', isOn);
      btn.setAttribute('aria-checked', isOn ? 'true' : 'false');
    });

    bundleCurrentRows.forEach(function (row) {
      row.hidden = row.dataset.vrsBundleCurrentRow !== handle;
    });

    bundleSizeGrids.forEach(function (grid) {
      var isActive = grid.dataset.partnerHandle === handle;
      grid.hidden = !isActive;
      if (isActive && opts && opts.resetSize) {
        grid.querySelectorAll('[data-variant-id]').forEach(function (b) {
          b.classList.remove('varsy-pdp-info__size--on');
          b.setAttribute('aria-checked', 'false');
        });
      }
    });

    if (opts && opts.resetSize) bundlePartnerVariant[handle] = null;
  }

  function recomputeBundle(mainVariantOverride) {
    /* Deliberately independent of bundleActiveChoice -- the bundle
       row's own price/label/saving must show whether or not it's the
       active choice (that's the whole point of the collapsed row), so
       this can't bail out just because "Buy 1" is currently selected.
       window.VarsyBundle.getActiveBundle() still separately gates on
       bundleActiveChoice, so nothing here can be submitted unless the
       bundle option is actually the one chosen. */
    if (!bundleRoot || !bundleData || !bundleActivePartner) return;

    var partner = bundleData.partners[bundleActivePartner];
    if (!partner) return;

    /* The main product's size may not be chosen yet. Fall back to a real
       variant so the bundle row can still show its price (all sizes share
       one price), but remember whether a size was actually picked -- the
       bundle only becomes submittable once it was. */
    var mainSelected = mainVariantOverride || findVariant(selected);
    var mainVariant = mainSelected || seedVariant;
    if (!mainVariant) return;

    var pairKey = [bundleData.mainCategory, partner.category].sort().join('+');
    var rule = bundleData.priceTable[pairKey];
    if (!rule) return;

    if (bundleLabelEl) bundleLabelEl.textContent = rule.label || '';
    if (bundleSubEl) {
      bundleSubEl.textContent = (bundleData.bundleSubTemplate || '').replace('{partner}', partner.title);
    }
    if (bundleSinglePriceEl) bundleSinglePriceEl.textContent = money(mainVariant.price);

    var partnerVariantId = bundlePartnerVariant[bundleActivePartner];
    var partnerVariant = partnerVariantId ? partner.variants[partnerVariantId] : null;

    /* Every size of a given product carries the same price, so the
       bundle price/compare/saving can show as soon as a partner is
       picked -- no need to wait on a specific size. Fall back to the
       partner's default variant purely for that display price; the
       CTA still stays disabled below until a real size is chosen, so
       nothing can submit against an unresolved variant. */
    var displayVariant = partnerVariant || partner.variants[partner.defaultVariantId];
    if (!displayVariant) return;

    var mainPriceCents    = mainVariant.price;
    var partnerPriceCents = displayVariant.price;
    var bundlePriceCents  = Math.round(parseFloat(rule.price) * 100);
    var compareAtCents    = mainPriceCents + partnerPriceCents;
    var savingCents       = compareAtCents - bundlePriceCents;

    if (bundlePriceEl) bundlePriceEl.textContent = money(bundlePriceCents);
    if (bundleCompareEl) bundleCompareEl.textContent = money(compareAtCents);
    if (bundleSavingEl) {
      bundleSavingEl.textContent = (bundleData.savingLabel || '').replace('{amount}', money(savingCents));
    }

    if (!partnerVariant || !mainSelected) {
      /* Either half still unchosen -- prices are shown, but nothing is
         submittable until both the main size and the partner size exist. */
      bundleActiveState = null;
      updateBundleCtaState();
      return;
    }

    /* Allocate the flat bundle price proportionally across both real
       line items (never a synthetic bundle SKU) so Shopify inventory
       decrements correctly on both products and per-product revenue
       reporting stays accurate. The partner line absorbs the rounding
       remainder so the two allocations always sum to the bundle price
       exactly -- see the bundle-widget plan for the full rationale. */
    var sumCents = mainPriceCents + partnerPriceCents;
    var ratio = sumCents > 0 ? (bundlePriceCents / sumCents) : 0;
    var mainAllocCents = Math.round(mainPriceCents * ratio);
    var partnerAllocCents = bundlePriceCents - mainAllocCents;

    var mainTitleEl = document.querySelector('.varsy-pdp-info__title');

    bundleActiveState = {
      label: rule.label || '',
      priceCents: bundlePriceCents,
      compareAtCents: compareAtCents,
      lineItems: [
        {
          variant_id: mainSelected.id,
          quantity: 1,
          title: mainTitleEl ? mainTitleEl.textContent.trim() : '',
          variant_title: mainVariant.title || '',
          price: mainAllocCents
        },
        {
          variant_id: parseInt(partnerVariantId, 10),
          quantity: 1,
          title: partner.title,
          variant_title: partnerVariant.title || '',
          price: partnerAllocCents
        }
      ]
    };

    updateBundleCtaState();
  }

  /* ── Partner picker (bottom sheet on mobile, centered dialog on
     desktop via CSS) -- same open/close idiom as varsy-cod-modal.liquid. */

  function openBundlePicker() {
    if (!bundlePicker) return;
    bundlePickerLastFocused = document.activeElement;
    bundlePicker.hidden = false;
    requestAnimationFrame(function () {
      bundlePicker.classList.add('varsy-bundle__picker--open');
    });
    bundlePicker.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var firstItem = bundlePicker.querySelector('[data-vrs-bundle-picker-item]');
    if (firstItem) firstItem.focus();
  }

  function closeBundlePicker() {
    if (!bundlePicker) return;
    bundlePicker.classList.remove('varsy-bundle__picker--open');
    bundlePicker.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!bundlePicker.classList.contains('varsy-bundle__picker--open')) bundlePicker.hidden = true;
    }, 320);
    if (bundlePickerLastFocused && bundlePickerLastFocused.focus) bundlePickerLastFocused.focus();
  }

  bundleChoiceBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setBundleChoice(btn.dataset.vrsBundleChoice);
      recomputeBundle();
    });
  });

  if (bundleOpenPickerBtn) {
    bundleOpenPickerBtn.addEventListener('click', function () {
      openBundlePicker();
    });
  }

  bundlePickerClose.forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeBundlePicker();
    });
  });

  if (bundlePicker) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && bundlePicker.classList.contains('varsy-bundle__picker--open')) closeBundlePicker();
    });
  }

  bundlePickerItems.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setBundleChoice('bundle');
      setBundlePartner(btn.dataset.vrsBundlePickerItem, { resetSize: true });
      recomputeBundle();
      closeBundlePicker();
    });
  });

  bundleSizeGrids.forEach(function (grid) {
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-variant-id]');
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var handle = grid.dataset.partnerHandle;
      grid.querySelectorAll('[data-variant-id]').forEach(function (b) {
        b.classList.remove('varsy-pdp-info__size--on');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('varsy-pdp-info__size--on');
      btn.setAttribute('aria-checked', 'true');
      bundlePartnerVariant[handle] = btn.dataset.variantId;
      if (handle === bundleActivePartner) recomputeBundle();
    });
  });

  window.VarsyBundle = {
    getActiveBundle: function () {
      return bundleActiveChoice === 'bundle' ? bundleActiveState : null;
    }
  };

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var idx = parseInt(btn.dataset.vrsOptionIndex, 10);
      selected[idx] = btn.dataset.vrsOptionValue;
      refreshSelectedClasses();
      refreshAvailability();
      updateBuyState();
      recomputeBundle();
    });
  });

  refreshAvailability();
  updateBuyState();

  if (bundleRoot) {
    setBundleChoice(bundleActiveChoice);
    recomputeBundle(currentVariant);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-product-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-vrs-sticky]');
  if (!bar) return;

  var addBtn   = document.querySelector('[data-vrs-add]');
  if (!addBtn) return;

  var info     = document.querySelector('[data-vrs-product-info]');
  var sizeSlot = bar.querySelector('[data-vrs-sticky-size]');
  var priceEl  = bar.querySelector('[data-vrs-sticky-price]');
  var ctaBtn   = bar.querySelector('[data-vrs-sticky-cta]');
  var form     = info ? info.querySelector('[data-vrs-form]') : null;

  var shown = false;

  function show() {
    if (shown) return;
    shown = true;
    bar.hidden = false;
    requestAnimationFrame(function () {
      bar.classList.add('varsy-pdp-sticky--shown');
    });
  }

  function hide() {
    if (!shown) return;
    shown = false;
    bar.classList.remove('varsy-pdp-sticky--shown');
    setTimeout(function () {
      if (!shown) bar.hidden = true;
    }, 320);
  }

  /* Show bar only after buy button scrolls off the TOP — not on initial page load */
  var ctaObserver = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    if (entry.isIntersecting) {
      hide();
    } else if (entry.boundingClientRect.bottom < 0) {
      show();
    }
    /* entry below viewport on load → do nothing */
  }, { threshold: 0 });
  ctaObserver.observe(addBtn);

  /* Reflect selected size into sticky title */
  if (sizeSlot) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vrs-size]');
      if (!btn || btn.classList.contains('varsy-pdp-info__size--out')) return;
      sizeSlot.textContent = ' · ' + btn.dataset.vrsSize;
    });
  }

  /* Mirror price -- the bundle price while a bundle is selected (its own
     [data-vrs-bundle-price] node in the bundle widget), otherwise the
     regular sale-price node (never the struck-through compare-at price
     sitting alongside it, which is why this doesn't just read textContent
     off a shared parent). A single broad observer on the whole product
     info root covers both sources plus the bundle CTA's hidden toggle,
     which is what actually decides which one currently applies. */
  function updateStickyPrice() {
    if (!priceEl || !info) return;
    var bundleCta = document.querySelector('[data-vrs-bundle-cta]');
    var bundlePrice = info.querySelector('[data-vrs-bundle-price]');
    if (bundleCta && !bundleCta.hidden && bundlePrice && bundlePrice.textContent) {
      priceEl.textContent = bundlePrice.textContent;
      return;
    }
    var inlinePrice = info.querySelector('[data-vrs-price-sale]');
    if (inlinePrice) priceEl.textContent = inlinePrice.textContent;
  }

  if (priceEl && info) {
    updateStickyPrice();
    new MutationObserver(updateStickyPrice).observe(info, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden']
    });
  }

  /* Sticky CTA: opens the bundle COD popup while a bundle is selected
     (reuses the bundle CTA button already in the buy section rather than
     duplicating its open logic), otherwise submits the main product form
     exactly as before. */
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      var bundleCta = document.querySelector('[data-vrs-bundle-cta]');
      var bundleCodBtn = bundleCta && !bundleCta.hidden ? bundleCta.querySelector('[data-vrs-cod-open]') : null;
      if (bundleCodBtn) {
        bundleCodBtn.click();
        return;
      }
      /* No size chosen yet means the form carries no variant id, so
         submitting would fail silently. Send them to the size grid. */
      var mainAdd = info ? info.querySelector('[data-vrs-add]') : null;
      if (mainAdd && mainAdd.disabled) {
        var sizes = info.querySelector('[data-vrs-sizes]');
        if (sizes) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          sizes.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        }
        return;
      }
      if (form) {
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-product-wheel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWheel(root) {
    if (root.dataset.vrsInit) return;
    root.dataset.vrsInit = '1';

    var count = parseInt(root.dataset.cardCount, 10);
    if (!count || count < 1) return;

    var angleStep  = 360 / count;
    var wheel      = root.querySelector('[data-vrs-wheel]');
    var stage      = root.querySelector('[data-vrs-stage]');
    var idxEl      = root.querySelector('[data-vrs-idx]');
    var cards      = root.querySelectorAll('.varsy-wheel__card');
    var dots       = root.querySelectorAll('.varsy-wheel__dot');
    var autoRotate = root.dataset.autoRotate === 'true';
    var autoSpeed  = parseFloat(root.dataset.autoSpeed) || 0.3;
    var scrollFac  = parseFloat(root.dataset.scrollFactor) || 0.18;
    var respectRm  = root.dataset.respectMotion !== 'false';
    var reducedMo  = respectRm && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var autoAngle  = 0;
    var scrollAngle = 0;
    var dragAngle  = 0;
    var activeIdx  = 0;
    var dragging   = false;
    var dragStartX = 0;
    var dragStartDrag = 0;

    function total() { return autoAngle + scrollAngle + dragAngle; }

    function wrap(n) { return ((n % count) + count) % count; }

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function applyTransform(skipTransition) {
      if (skipTransition) wheel.style.transition = 'none';
      wheel.style.transform = 'rotateY(' + (-total()) + 'deg)';
    }

    function updateActive() {
      var idx = wrap(Math.round(total() / angleStep));
      if (idx === activeIdx) return;
      activeIdx = idx;

      cards.forEach(function (c, i) {
        c.classList.toggle('is-active', i === activeIdx);
      });
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.dataset.i, 10) === activeIdx);
      });
      if (idxEl) {
        idxEl.textContent = pad(activeIdx + 1) + ' / ' + pad(count);
      }
    }

    function render(skipTransition) {
      applyTransform(skipTransition);
      updateActive();
    }

    function snapTo(targetIdx) {
      /* Navigate to targetIdx via shortest arc */
      var cur = wrap(Math.round(total() / angleStep));
      var diff = targetIdx - cur;
      if (diff >  count / 2) diff -= count;
      if (diff < -count / 2) diff += count;
      dragAngle += diff * angleStep;
      wheel.style.transition = '';
      render(false);
    }

    /* ── Auto-rotate ─────────────────────────────────────── */
    var autoTimer = null;
    if (autoRotate && !reducedMo) {
      autoTimer = setInterval(function () {
        if (!dragging) {
          autoAngle += autoSpeed;
          render(false);
        }
      }, 60);
    }

    /* ── Scroll-linked rotation ──────────────────────────── */
    if (!reducedMo) {
      window.addEventListener('scroll', function () {
        scrollAngle = window.scrollY * scrollFac;
        render(false);
      }, { passive: true });
    }

    /* ── Drag (touch + mouse) ────────────────────────────── */
    function startDrag(x) {
      dragging = true;
      dragStartX = x;
      dragStartDrag = dragAngle;
      wheel.style.transition = 'none';
    }

    function moveDrag(x) {
      if (!dragging) return;
      dragAngle = dragStartDrag + (dragStartX - x) * 0.35;
      applyTransform(true);
    }

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      wheel.style.transition = '';
      /* Snap to nearest card */
      var snapped = Math.round(total() / angleStep) * angleStep;
      dragAngle = snapped - autoAngle - scrollAngle;
      render(false);
    }

    stage.addEventListener('touchstart',  function (e) { startDrag(e.touches[0].clientX); }, { passive: true });
    stage.addEventListener('touchmove',   function (e) { moveDrag(e.touches[0].clientX);  }, { passive: true });
    stage.addEventListener('touchend',    endDrag);
    stage.addEventListener('touchcancel', endDrag);

    stage.addEventListener('mousedown', function (e) { startDrag(e.clientX); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (dragging) moveDrag(e.clientX); });
    window.addEventListener('mouseup',   function ()  { if (dragging) endDrag(); });

    /* ── Dot clicks ──────────────────────────────────────── */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        snapTo(parseInt(dot.dataset.i, 10));
      });
    });

    /* ── Keyboard (left/right on the stage) ─────────────── */
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') snapTo(wrap(activeIdx + 1));
      if (e.key === 'ArrowLeft')  snapTo(wrap(activeIdx - 1));
    });
  }

  /* ── Boot ────────────────────────────────────────────────── */
  function boot(scope) {
    (scope || document).querySelectorAll('.varsy-wheel').forEach(initWheel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme editor re-render */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-side-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  var menu = document.querySelector('[data-vrs-side-menu]');
  if (!menu) return;

  var closers      = menu.querySelectorAll('[data-vrs-menu-close]');
  var localeToggle = menu.querySelector('[data-vrs-locale-toggle]');
  var localeList   = menu.querySelector('[data-vrs-locale-list]');
  var langToggle   = menu.querySelector('[data-vrs-lang-toggle]');
  var langList     = menu.querySelector('[data-vrs-lang-list]');
  var lastFocused  = null;

  function openMenu() {
    lastFocused = document.activeElement;
    menu.hidden = false;
    requestAnimationFrame(function () {
      menu.classList.add('varsy-side-menu--open');
    });
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = menu.querySelector('[data-vrs-menu-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    menu.classList.remove('varsy-side-menu--open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!menu.classList.contains('varsy-side-menu--open')) menu.hidden = true;
    }, 380);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-vrs-menu-open]');
    if (trigger) {
      e.preventDefault();
      openMenu();
      return;
    }
    var closer = e.target.closest('[data-vrs-menu-close]');
    if (closer && menu.contains(closer)) {
      e.preventDefault();
      closeMenu();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.classList.contains('varsy-side-menu--open')) closeMenu();
  });

  /* Locale dropdown */
  if (localeToggle && localeList) {
    localeToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = localeToggle.getAttribute('aria-expanded') === 'true';
      localeToggle.setAttribute('aria-expanded', String(!expanded));
      localeList.hidden = expanded;
    });
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target)) return;
      if (!localeList.contains(e.target) && !localeToggle.contains(e.target)) {
        localeList.hidden = true;
        localeToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Language dropdown */
  if (langToggle && langList) {
    langToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = langToggle.getAttribute('aria-expanded') === 'true';
      langToggle.setAttribute('aria-expanded', String(!expanded));
      langList.hidden = expanded;
    });
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target)) return;
      if (!langList.contains(e.target) && !langToggle.contains(e.target)) {
        langList.hidden = true;
        langToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  window.VarsySideMenu = { open: openMenu, close: closeMenu };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-story-highlights"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-vrs-stories]').forEach(init);

  function init(root) {
    var dataEl = root.querySelector('[data-vrs-stories-data]');
    var track = root.querySelector('[data-vrs-stories-track]');
    var viewer = root.querySelector('[data-vrs-story-viewer]');
    if (!dataEl || !track || !viewer) return;

    var highlights = [];
    try {
      highlights = (JSON.parse(dataEl.textContent) || {}).highlights || [];
    } catch (err) {
      console.error('Varsy stories: malformed story data, section hidden.', err);
    }
    if (!highlights.length) {
      root.hidden = true;
      return;
    }

    var frame = viewer.querySelector('[data-vrs-story-frame]');
    var img = viewer.querySelector('[data-vrs-story-img]');
    var video = viewer.querySelector('[data-vrs-story-video]');
    var barsEl = viewer.querySelector('[data-vrs-story-bars]');
    var titleEl = viewer.querySelector('[data-vrs-story-title]');
    var muteBtn = viewer.querySelector('[data-vrs-story-mute]');
    var closeBtn = viewer.querySelector('[data-vrs-story-close]');
    var prevBtn = viewer.querySelector('[data-vrs-story-prev]');
    var nextBtn = viewer.querySelector('[data-vrs-story-next]');
    var cta = viewer.querySelector('[data-vrs-story-cta]');

    var imageMs = (parseInt(viewer.dataset.imageDuration, 10) || 5) * 1000;
    var muteLabel = viewer.dataset.muteLabel || 'Mute';
    var unmuteLabel = viewer.dataset.unmuteLabel || 'Unmute';
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var hIdx = 0;
    var sIdx = 0;
    var fills = [];
    var elapsed = 0;
    var lastTs = 0;
    var rafId = 0;
    var isOpen = false;
    var opener = null;
    var imgReady = false;
    var muted = false;

    /* Three independent reasons to pause; the story runs only when none apply. */
    var paused = false;
    var holdPaused = false;
    var hiddenPaused = false;
    var keyPaused = false;

    var preloadImg = new Image();

    function story() {
      return highlights[hIdx].stories[sIdx];
    }

    function buildBars() {
      barsEl.innerHTML = '';
      fills = [];
      highlights[hIdx].stories.forEach(function () {
        var bar = document.createElement('span');
        bar.className = 'varsy-story-viewer__bar';
        var fill = document.createElement('span');
        fill.className = 'varsy-story-viewer__fill';
        bar.appendChild(fill);
        barsEl.appendChild(bar);
        fills.push(fill);
      });
    }

    function setFill(i, ratio) {
      if (!fills[i]) return;
      fills[i].style.transform = 'scaleX(' + Math.max(0, Math.min(1, ratio)) + ')';
    }

    function syncBars() {
      fills.forEach(function (fill, i) {
        setFill(i, i < sIdx ? 1 : 0);
      });
    }

    function updateMuteButton() {
      var isVideo = story().type === 'video';
      muteBtn.hidden = !isVideo;
      muteBtn.setAttribute('aria-label', muted ? unmuteLabel : muteLabel);
      var icon = muteBtn.querySelector('i');
      if (icon) icon.className = 'ti ' + (muted ? 'ti-volume-off' : 'ti-volume');
    }

    /* One <video> element is reused for every video story. The tap that
       opened the player unlocks that element for sound, and reusing it is
       what lets later videos auto-play with sound on iOS Safari. If sound
       is refused anyway, drop to muted rather than freezing the story. */
    function playVideo() {
      video.muted = muted;
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          if (muted) return;
          muted = true;
          video.muted = true;
          updateMuteButton();
          video.play().catch(function () {});
        });
      }
    }

    function nextStoryRef() {
      var stories = highlights[hIdx].stories;
      if (sIdx + 1 < stories.length) return stories[sIdx + 1];
      if (hIdx + 1 < highlights.length) return highlights[hIdx + 1].stories[0];
      return null;
    }

    /* Images only -- videos never download ahead of their own story. */
    function preloadNext() {
      var upcoming = nextStoryRef();
      if (upcoming && upcoming.type === 'image') preloadImg.src = upcoming.src;
    }

    function show(i) {
      sIdx = i;
      elapsed = 0;
      lastTs = 0;
      syncBars();

      var current = story();
      var highlight = highlights[hIdx];

      titleEl.textContent = highlight.title || '';
      if (highlight.link) {
        cta.href = highlight.link;
        cta.hidden = false;
      } else {
        cta.hidden = true;
      }

      if (current.type === 'video') {
        img.hidden = true;
        img.removeAttribute('src');
        video.hidden = false;
        if (current.poster) video.poster = current.poster;
        if (video.getAttribute('src') !== current.src) video.src = current.src;
        try { video.currentTime = 0; } catch (err) {}
        if (!paused) playVideo();
      } else {
        video.pause();
        video.hidden = true;
        imgReady = false;
        img.src = current.src;
        if (img.complete && img.naturalWidth) imgReady = true;
        img.hidden = false;
      }

      updateMuteButton();
      preloadNext();
    }

    function openHighlight(h, s) {
      hIdx = h;
      buildBars();
      show(s);
    }

    function next() {
      if (sIdx + 1 < highlights[hIdx].stories.length) return show(sIdx + 1);
      if (hIdx + 1 < highlights.length) return openHighlight(hIdx + 1, 0);
      close();
    }

    function prev() {
      if (sIdx > 0) return show(sIdx - 1);
      if (hIdx > 0) return openHighlight(hIdx - 1, 0);
      show(0);
    }

    function setPaused(value) {
      if (paused === value) return;
      paused = value;
      lastTs = 0;
      if (!isOpen || story().type !== 'video') return;
      if (paused) video.pause();
      else playVideo();
    }

    function refreshPause() {
      setPaused(holdPaused || hiddenPaused || keyPaused);
    }

    function tick(ts) {
      if (!isOpen) return;
      var dt = lastTs ? ts - lastTs : 0;
      lastTs = ts;

      if (!paused) {
        if (story().type === 'video') {
          if (video.duration && isFinite(video.duration)) setFill(sIdx, video.currentTime / video.duration);
        } else if (imgReady) {
          /* The clock only runs once the image is actually on screen, so a
             slow image can't time out before anyone has seen it. */
          elapsed += dt;
          setFill(sIdx, elapsed / imageMs);
          if (elapsed >= imageMs) next();
        }
      }

      if (isOpen) rafId = requestAnimationFrame(tick);
    }

    function open(h, s, trigger) {
      opener = trigger || document.activeElement;
      isOpen = true;
      paused = false;
      holdPaused = false;
      hiddenPaused = false;
      keyPaused = false;

      viewer.hidden = false;
      viewer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      /* Must run inside the tap's own call stack -- that's what unlocks
         video sound on mobile. */
      openHighlight(h, s);

      requestAnimationFrame(function () {
        viewer.classList.add('varsy-story-viewer--open');
      });

      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(tick);
      closeBtn.focus({ preventScroll: true });
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      cancelAnimationFrame(rafId);

      video.pause();
      video.removeAttribute('src');
      video.load(); /* aborts any in-flight video download */
      img.removeAttribute('src');

      viewer.classList.remove('varsy-story-viewer--open');
      viewer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      frame.style.transform = '';

      var finish = function () {
        if (!isOpen) viewer.hidden = true;
      };
      if (reduceMotion.matches) finish();
      else setTimeout(finish, 200);

      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }

    /* ── Carousel → player ─────────────────────────────── */

    track.addEventListener('click', function (e) {
      var card = e.target.closest('[data-vrs-story-open]');
      if (!card) return;
      var h = parseInt(card.dataset.h, 10);
      var s = parseInt(card.dataset.s, 10);
      if (!highlights[h] || !highlights[h].stories[s]) return;
      open(h, s, card);
    });

    /* ── Gestures: tap, press-and-hold to pause, swipe down to close ── */

    var pointer = null;
    var holdTimer = 0;
    var suppressClick = false;

    function swallowNextClick() {
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 350);
    }

    frame.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-vrs-story-close], [data-vrs-story-mute], [data-vrs-story-cta]')) return;
      pointer = { x: e.clientX, y: e.clientY, dy: 0, moved: false };
      suppressClick = false;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () {
        holdPaused = true;
        refreshPause();
      }, 220);
    });

    frame.addEventListener('pointermove', function (e) {
      if (!pointer) return;
      var dx = e.clientX - pointer.x;
      var dy = e.clientY - pointer.y;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
        pointer.moved = true;
        clearTimeout(holdTimer);
      }
      pointer.dy = dy;
      if (dy > 0) {
        frame.style.transition = 'none';
        frame.style.transform = 'translateY(' + dy + 'px)';
      }
    });

    function endPointer() {
      if (!pointer) return;
      clearTimeout(holdTimer);
      var dy = pointer.dy;
      var moved = pointer.moved;
      pointer = null;
      frame.style.transition = '';
      frame.style.transform = '';

      if (dy > 90) {
        swallowNextClick();
        close();
        return;
      }
      if (holdPaused) {
        holdPaused = false;
        refreshPause();
        swallowNextClick();
        return;
      }
      if (moved) swallowNextClick();
    }

    frame.addEventListener('pointerup', endPointer);
    frame.addEventListener('pointercancel', endPointer);

    prevBtn.addEventListener('click', function () {
      if (suppressClick) return;
      prev();
    });

    nextBtn.addEventListener('click', function () {
      if (suppressClick) return;
      next();
    });

    closeBtn.addEventListener('click', close);

    muteBtn.addEventListener('click', function () {
      muted = !muted;
      video.muted = muted;
      updateMuteButton();
      if (!muted && !paused && story().type === 'video') playVideo();
    });

    video.addEventListener('ended', function () {
      if (isOpen && story().type === 'video') next();
    });

    /* A broken video skips ahead instead of stranding the player. */
    video.addEventListener('error', function () {
      if (isOpen && video.getAttribute('src') && story().type === 'video') next();
    });

    img.addEventListener('load', function () { imgReady = true; });
    img.addEventListener('error', function () { imgReady = true; });

    /* ── Keyboard + focus ──────────────────────────────── */

    function focusables() {
      return Array.prototype.filter.call(viewer.querySelectorAll('button, a[href]'), function (el) {
        return !el.hidden;
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        if (rtl) prev(); else next();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        if (rtl) next(); else prev();
      } else if (e.key === ' ' && !e.target.closest('a, [data-vrs-story-mute], [data-vrs-story-close]')) {
        e.preventDefault();
        keyPaused = !keyPaused;
        refreshPause();
      } else if (e.key === 'Tab') {
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    /* Leaving the tab (or opening Instagram from the button) pauses. */
    document.addEventListener('visibilitychange', function () {
      if (!isOpen) return;
      hiddenPaused = document.hidden;
      refreshPause();
    });

    /* Theme editor re-renders the section on every setting change --
       never leave the page scroll-locked behind a vanished player. */
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains(root)) close();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varsy-thank-you"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Order value/currency/id are passed as URL query params by the COD
     modal on redirect (see varsy-cod-modal.liquid). Exposed on window
     for whatever conversion tracking (Meta Pixel, GTM, etc.) gets added
     here -- intentionally not wired to any specific tracking snippet. */
  var params = new URLSearchParams(window.location.search);
  window.varsyOrderValue    = params.get('value');
  window.varsyOrderCurrency = params.get('currency');
  window.varsyOrderId       = params.get('order_id');

  // ---------------------------------------------------------------
  // Conversion tracking goes here, e.g.:
  //   fbq('track', 'Purchase', {
  //     value: parseFloat(window.varsyOrderValue),
  //     currency: window.varsyOrderCurrency
  //   });
  // ---------------------------------------------------------------
})();

  } catch(e) { console.error(e); }
})();
})();
